/**
 * @generated SignedSource<<379bea81e9c6191066797b963f9dc8d1>>
 * @relayHash 074ccfda4f0a4e006a4460e28d942698
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c812d8320a9f3d2fcc9343252afd653375e101091fc231dfb143f19ad1a5a51

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareSummaryAppQuery } from './JiraSoftwareSummaryAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareSummaryAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3c812d8320a9f3d2fcc9343252afd653375e101091fc231dfb143f19ad1a5a51",
    "metadata": {},
    "name": "JiraSoftwareSummaryAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
